import { useIntl } from '@capsicum/common';
import { GenericDrawer, useGoatImage } from '@capsicum/common-web';

export type ConfirmationErrorModalProps = {
	onButtonPress: () => void;
	onSecondaryActionOnButtonPress: () => void;
	testID: string;
};

export const ConfirmationErrorModal = ({
	onButtonPress,
	onSecondaryActionOnButtonPress,
	testID
}: ConfirmationErrorModalProps) => {
	const { $t } = useIntl();
	const goatAlertImage = useGoatImage('alert');

	const confirmationErrorDrawerData = {
		buttonText: $t('withdrawal.confirmationError.tryAgain'),
		description: $t('withdrawal.confirmationError.errorDescription'),
		image: goatAlertImage,
		isButtonFullWidth: true,
		isButtonOnRow: false,
		onButtonPress,
		onSecondaryActionOnButtonPress,
		secondaryActionButtonText: $t('withdrawal.confirmationError.customerSupport'),
		testID: testID,
		title: $t('withdrawal.confirmationError.errorTitle')
	};

	return <GenericDrawer {...confirmationErrorDrawerData} />;
};
